import {
    AllowedWebsiteTemplateSystemIdSchema,
    defaultIntegratedWebsiteDisplayNameBySystemId,
    ThirdPartySystemId,
} from '@pillar-portal/api-types';

export function formatAllowedWebsiteTemplateSystemName(systemId: number): string {
    if (systemId === ThirdPartySystemId.GENERIC) {
        return 'Generic';
    }
    const parseResult = AllowedWebsiteTemplateSystemIdSchema.safeParse(systemId);
    if (!parseResult.success) {
        return 'Unsupported allowed website';
    }
    return (
        defaultIntegratedWebsiteDisplayNameBySystemId[parseResult.data] ??
        'Unsupported allowed website'
    );
}
